import { collection, deleteDoc, doc, getDocs, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "./firebase";

export async function getBlockedUserIds(uid: string) {
  if (!uid) return new Set<string>();

  const snap = await getDocs(collection(db, "users", uid, "blockedUsers"));
  return new Set(snap.docs.map((item) => item.id).filter(Boolean));
}

export async function blockUser(params: { uid: string; blockedUid: string }) {
  const blockedUid = params.blockedUid.trim();

  if (!params.uid || !blockedUid || params.uid === blockedUid) {
    throw new Error("Utilisateur a bloquer invalide.");
  }

  await setDoc(doc(db, "users", params.uid, "blockedUsers", blockedUid), {
    blockedUid,
    createdAt: serverTimestamp(),
  });
}

export async function unblockUser(params: { uid: string; blockedUid: string }) {
  const blockedUid = params.blockedUid.trim();

  if (!params.uid || !blockedUid) return;

  await deleteDoc(doc(db, "users", params.uid, "blockedUsers", blockedUid));
}
